
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/um",
      function () {
        return require("private-next-pages/um/fyrirtaekid/um.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/um"])
      });
    }
  